import { useLingui } from "@lingui/react";
import { ApiDatafanSmp } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "datafan.providers";

export const PROVIDERS_WHITELIST: Record<string, boolean | undefined> = {
  facebook: true,
  inst: true,
  ok: true,
  vk: true,
} as const;

type Response = Await<ReturnType<typeof ApiDatafanSmp.Providers.list>>;

export const useQueryDatafanProviders = (
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn" | "select">,
) => {
  const { i18n } = useLingui();
  const lang = i18n.locale === "ru" ? "ru" : "en";

  return useQuery<Response>(
    [KEY],
    () => ApiDatafanSmp.Providers.list({ lang }),
    {
      ...options,
      select: (data) =>
        data.filter((provider) => !!PROVIDERS_WHITELIST[provider.medium]),
    },
  );
};

useQueryDatafanProviders.KEY = KEY;
